export default (that) => [
  {
    text: that.$l('tips_text_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('tips_text_edit') || '编辑单据',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'E',
    data: {},
    disabled: ({ productStockInStatus }) => productStockInStatus === 'N' || productStockInStatus === 'Y',
  },
  {
    text: that.$l('tips_text_delete') || '删除单据',
    icon: 'el-icon-delete',
    menuType: 'delete',
    divided: false,
    allow: 'D',
    data: {},
    disabled: ({ productStockInStatus }) => productStockInStatus === 'N' || productStockInStatus === 'Y',
  },
  {
    text: that.$l('tips_text_audit') || '审核单据',
    icon: 'el-icon-s-check',
    menuType: 'audit',
    divided: true,
    allow: 'T',
    data: {},
    disabled: ({ productStockInStatus }) => productStockInStatus === 'N' || productStockInStatus === 'Y' ,
  },
]
